import _ from 'lodash'
import levenshtein from 'fast-levenshtein'

export default {
  props: {
    input: {
      type: String,
    },
  },
  data() {
    return {
      samples: this.$store.state.globals.typoRecognitionSamples,
      suggestion: null,
      tolerance: 3,
    }
  },
  methods: {
    findClosestDomain() {
      // If input domain exists
      if (!this.domain.length) {
        return false
      }
      for (const sample of this.samples) {
        // In case of exact match
        if (sample === this.domain) {
          return false
        }
        // Check for similarity
        const match = levenshtein.get(this.domain, sample)
        if (match < this.tolerance) {
          return sample
        }
      }
    },
    fixTypo() {
      this.$emit('correct', `${this.username}@${this.suggestion}`)
      this.suggestion = null
    },
    makeSuggestion() {
      const match = this.findClosestDomain()
      if (match) {
        this.suggestion = match
      } else {
        this.suggestion = null
      }
    },
  },
  computed: {
    domain() {
      return this.input.replace(/.*@/, '')
    },
    message() {
      if (this.suggestion) {
        return ''
      }
      return null
    },
    username() {
      return this.input.replace(/@.*$/, '')
    },
  },
  watch: {
    input: _.debounce(function() {
      this.makeSuggestion()
    }, 500),
  },
}
